import { matchRoutePattern } from '@/ws/fallback/matchRoutePattern';
import { WsFallbackConfig } from '@/ws/fallback/types';

export function resolveCustomRefetcher(
  config: WsFallbackConfig,
  pathname: string,
): (() => Promise<unknown>) | undefined {
  if (!config.customRefetchers) return undefined;

  const matched = matchRoutePattern(config.customRefetchers, pathname);
  if (!matched) return undefined;

  return () => matched.entry(matched.params);
}
